// src/Utils/useTableFade.js
import { useState, useRef } from "react";

export const useTableFade = () => {
  const skipSpinnerRef = useRef(false);
  const [tableLoading, setTableLoading] = useState(false);

  const triggerTableLoading = () => {
    skipSpinnerRef.current = true;
    setTableLoading(true);
  };

  const stopTableLoading = () => {
    skipSpinnerRef.current = false;
    setTableLoading(false);
  };

  return { skipSpinnerRef, tableLoading, triggerTableLoading, stopTableLoading };
};
